import React, { Fragment, useState, useEffect, useRef, useCallback } from "react";
// import ServicesSwitch from "../Switch/ServicesSwitch.jsx";
import { useTranslation } from "react-i18next";
import { Dialog /*, PaginationHelper*/ } from "webapp/components";

import lockoutIcon from "assets/ui-img/lockoutOption.png";
import gasIcon from "assets/ui-img/gasOption.png";
import startIcon from "assets/ui-img/boostOption.png";
import tiresIcon from "assets/ui-img/flatOption.png";
import winchIcon from "assets/ui-img/winchOption.png";
import towIcon from "assets/ui-img/towOption.png";
import { CancelOutlined } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Slider from "@mui/material/Slider";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormLabel from "@mui/material/FormLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import TextField from "@mui/material/TextField";
import FormHelperText from "@mui/material/FormHelperText";
import { ServiceTypeDataHost, ServiceTypeHost, ServiceTypeOptionHost } from "./SelectServiceModel";
import "./SelectService.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { ALLOW_SCHEDULE_FOR_LATER } from "webapp/config/featureFlags";
const SERVICE_TYPE_TOW = "Tow";
const SERVICE_TYPE_WINCH = "Winch";
const SERVICE_TYPE_BOOST = "Boost";
const SERVICE_TYPE_FLAT = "Flat";
const SERVICE_TYPE_LOCKSMITH = "Locksmith";
const SERVICE_TYPE_GAS = "Gas";
const SERVICE_TYPE_LOCKOUT = "Lockout";
const SERVICE_TYPE_TIRESWAP = "TireSwap";

const SelectServiceList = function (props) {
  const [dataHost, setDataHost] = useState(props.dataHost); //**Entire service type data (ServiceTypeDataHost)
  const [services, setServices] = useState([]);
  const [productServiceTypeLimits, setProductServiceTypeLimits] = useState(props.productServiceTypeLimits || []);
  const { campaignDetails = [], onServiceCampaignSelected } = props;
  const [partnerCode, setPartnerCode] = useState(props.partnerCode || "");

  useEffect(() => {
    setDataHost(props.dataHost);
    setServices(props.dataHost.services);
  }, [props.dataHost]);

  const onServiceAdded = (newService) => {
    setServices([...dataHost.services]);
  };

  useEffect(() => {
    dataHost.addEventListener("onServiceAdded", onServiceAdded);
    return () => {
      dataHost.removeEventListener("onServiceAdded", onServiceAdded);
    };
  }, []);

  const isServiceHasPrice = (service) => {
    if (partnerCode !== "PBFL") {
      return true;
    }
    let price = productServiceTypeLimits.find((limit) => limit.serviceType === service.value)?.fixedPrice;
    return price > 0;
  };

  return (
    <>
      {/* Map through each service */}
      {services.map((service, index) =>
        isServiceHasPrice(service) ? (
          <SelectServiceListItem
            key={`select-service-list-item-${index}-${service?.value}`}
            serviceHost={service}
            productServiceTypeLimits={productServiceTypeLimits}
            campaignDetails={campaignDetails}
            partnerCode={partnerCode}
            onServiceCampaignSelected={onServiceCampaignSelected}
          />
        ) : null,
      )}
    </>
  );
};

const SelectServiceListItem = function (props) {
  const [serviceHost, setServiceHost] = useState(props.serviceHost); //represents each service
  const [label] = useState(props.serviceHost.label || ""); //ex: Tow
  const [value] = useState(props.serviceHost.value || ""); //ex Tow
  const [selected, setSelected] = useState(!!props.serviceHost.selected);
  const [icon] = useState(props.serviceHost.icon || "");
  const [iconAlt] = useState(props.serviceHost.iconAlt || "");

  const [options, setOptions] = useState(props.serviceHost.options || []);
  const [productServiceTypeLimits, setProductServiceTypeLimits] = useState(props.productServiceTypeLimits || []);
  const [partnerCode, setPartnerCode] = useState(props.partnerCode || "");
  const { campaignDetails = [], onServiceCampaignSelected } = props;
  const optionsEndRef = useRef(null);
  const prevVisibleCountRef = useRef(0);

  const onSelectedChanged = (val) => {
    setSelected(!!val);
    setOptions([...serviceHost.options]);
  };

  const onOptionValueChange = (optionHost) => {
    setOptions([...serviceHost.options]);
  };

  useEffect(() => {
    serviceHost.addEventListener("onSelectedChanged", onSelectedChanged);
    serviceHost.addEventListener("onOptionValueChange", onOptionValueChange);

    return () => {
      serviceHost.removeEventListener("onSelectedChanged", onSelectedChanged);
      serviceHost.removeEventListener("onOptionValueChange", onOptionValueChange);
    };
  }, []);

  // Auto-scroll when a service is selected or new follow-up questions appear
  useEffect(() => {
    if (!selected) {
      prevVisibleCountRef.current = 0;
      return;
    }

    const visibleCount = options.filter((option) => option.isVisible()).length;
    if (visibleCount === 0 || visibleCount === prevVisibleCountRef.current) {
      return;
    }

    prevVisibleCountRef.current = visibleCount;
    const timeoutId = setTimeout(() => {
      optionsEndRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "end",
      });
    }, 50);

    return () => clearTimeout(timeoutId);
  }, [selected, options]);

  // useEffect(() => {
  //   setServiceHost(props.serviceHost);
  // }, []);
  const serviceStyle = {
    display: "flex",
    justifyContent: "space-between",
    padding: 10,
    background: "white",
    borderColor: "darkgray",
    borderBottom: "1px solid lightgray",
  };

  const serviceLabelStyle = {
    marginTop: "auto",
    marginBottom: "auto",
    marginLeft: 20,
    fontSize: 18,
  };

  const isCampaignApply = (service) => {
    if (partnerCode !== "PBFL") return false;
    const campaignDetail = campaignDetails.find((campaign) => campaign.serviceType === service);
    if (!campaignDetail || !campaignDetail.campaignIsActive) return false;
    return campaignDetail;
  };

  const getServicePricePBFL = (service) => {
    const campaignDetail = isCampaignApply(service);
    if (!campaignDetail) {
      const regularPrice = productServiceTypeLimits.find((limit) => limit.serviceType === service)?.fixedPrice || 0;
      return <span>${regularPrice}</span>;
    }
    const promotionPrice = `${campaignDetail.fixedDistanceFee} ×  Tow Miles`;
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <span>${promotionPrice}</span>
        <span style={{ fontSize: 10 }}>After {campaignDetail.fixedDistanceLimit} miles</span>
      </div>
    );
  };

  return (
    <div>
      {/* <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}> */}
      <div style={serviceStyle}>
        <div
          style={{
            marginLeft: 8,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img style={{ width: 40, height: 40 }} src={icon} alt={iconAlt} />
          <p style={serviceLabelStyle}>{label}</p>
        </div>

        <Button
          variant="contained"
          color={selected ? "success" : "primary"}
          sx={{ textTransform: "none" }}
          onClick={() => {
            serviceHost.setSelected(true);
            if (partnerCode === "PBFL") {
              onServiceCampaignSelected?.(value);
            }
          }}
        >
          {partnerCode === "PBFL" ? getServicePricePBFL(value) : selected ? "Selected" : "Select"}
        </Button>
      </div>
      {/* 
        <div
          style={{
            paddingLeft: "1rem",
            paddingTop: 4,
            fontSize: 14,
            color: "black",
            backgroundColor: "white",
            borderBottom: value === SERVICE_TYPE_TOW ? "none" : "1px solid lightgray",
            paddingBottom: value === SERVICE_TYPE_TOW && partnerCode === "PBFL" ? 0 : 4,
          }}
        >
          {partnerCode === "PBFL" && (
            <>
              <strong>Fixed Price:</strong>$
              {productServiceTypeLimits.find((limit) => limit.serviceType === value)?.fixedPrice ||
                0}
            </>
          )}
        </div> */}

      {/* {value === SERVICE_TYPE_TOW && partnerCode === "PBFL" && (
          <div
            style={{
              paddingLeft: "1rem",
              paddingTop: 4,
              fontSize: 14,
              color: "black",
              backgroundColor: "white",
              borderBottom: "1px solid lightgray",
              paddingBottom: 4,
            }}
          >
            <strong>Fixed Distance Fee: </strong>$
            {productServiceTypeLimits.find((limit) => limit.serviceType === value)
              ?.fixedDistanceFee || 0}
          </div>
        )} */}
      {/* </div> */}

      {/* After select the service type, map through all the sub options */}
      {selected &&
        options.length > 0 &&
        options.map((optionHost) =>
          optionHost.isVisible() ? <SelectServiceListItemSubOptionList optionHost={optionHost} /> : <></>,
        )}
      {selected && options.length > 0 && <div ref={optionsEndRef} />}
    </div>
  );
};

const SelectServiceListItemSubOptionList = function (props) {
  const [optionHost] = useState(props.optionHost || {});
  const [title] = useState(props.optionHost.title || "");
  const [type] = useState(props.optionHost.type || "");
  const [value, setValue] = useState(props.optionHost.value);
  const [values] = useState(props.optionHost.values || []);
  const [sliderValue, setSliderValue] = useState(
    props.optionHost.value !== undefined && props.optionHost.value !== null ? props.optionHost.value : 0,
  );
  const [serviceTypeHost] = useState(optionHost.serviceHost || {});

  const [inputParams] = useState(props.optionHost.inputParams || {});

  const [render, setRender] = useState(false);

  const [marks, setMarks] = useState([]);
  const [isValidated, setIsValidated] = useState(true);
  const [errorMessage] = useState(props.optionHost.validationErrorMessage);

  const onValueChange = (val) => {
    setValue(val);
    setRender(!render);
  };

  const onValidate = (result) => {
    setIsValidated(!!result);
  };

  useEffect(() => {
    if (optionHost.type === "range") {
      const max = inputParams?.max ? inputParams.max : 0;
      const m = new Array(max + 1).fill(0).map((item, index) => {
        return {
          value: index,
          label: index === 3 ? "3+" : index,
        };
      });
      setMarks(m);
      // Default rider number (and any range option) to 0 when not set
      if (optionHost.value === undefined || optionHost.value === null) {
        optionHost.setValue(0);
        setSliderValue(0);
      }
    }
    optionHost.addEventListener("onValueChange", onValueChange);
    optionHost.addEventListener("onValidate", onValidate);
    return () => {
      optionHost.removeEventListener("onValueChange", onValueChange);
      optionHost.removeEventListener("onValidate", onValidate);
    };
  }, []);

  const changeSliderValue = (newValue) => {
    optionHost.setValue(newValue);
  };

  const subOptionStyle = {
    background: "white",
    padding: 24,
    borderBottom: "1px solid lightgray",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  };

  return (
    <>
      <fieldset id="group1">
        <div style={subOptionStyle}>
          {title && <p>{title}</p>}
          {/* Radio Buttons */}
          {type === "radio" && values?.length > 0 && (
            <FormControl error={!isValidated}>
              <RadioGroup
                aria-labelledby="demo-controlled-radio-buttons-group"
                name="controlled-radio-buttons-group"
                value={value}
              >
                {values?.length > 0 &&
                  values.map((item, index) => (
                    <FormControlLabel
                      value={item.value}
                      control={<Radio />}
                      label={" " + item.label}
                      onChange={(e) => {
                        e.preventDefault();
                        // setSelected(true);
                        optionHost.setValue(item.value);
                        // optionHost.isVisible();
                      }}
                    />
                  ))}
              </RadioGroup>
              {!isValidated && <FormHelperText id="errorHelperText">{errorMessage}</FormHelperText>}
            </FormControl>
          )}

          {/* Input Option */}
          {type === "input" && (
            <FormControl error={!isValidated}>
              <TextField
                id="outlined-basic"
                label="Distance"
                variant="outlined"
                size="small"
                type="number"
                error={!isValidated}
                onChange={(e) => {
                  optionHost.setValue(e.target.value);
                }}
              />
              {!isValidated && <FormHelperText id="errorHelperText">{errorMessage}</FormHelperText>}
            </FormControl>
          )}

          {/* Dropdown Options */}
          {type === "dropdown" && (
            <>
              <FormControl fullWidth size="small" error={!isValidated}>
                {/* <FormControl fullWidth size="small"> */}
                {/* <InputLabel id="demo-simple-select-label">{value}</InputLabel> */}
                <Select
                  value={value}
                  label={optionHost.label}
                  onChange={(e) => {
                    optionHost.setValue(e.target.value);
                  }}
                  MenuProps={{
                    PaperProps: {
                      style: {
                        maxHeight: 250,
                        overflowY: "auto",
                      },
                    },
                  }}
                >
                  {values.map((item) => {
                    return <MenuItem value={item.value}>{item.label}</MenuItem>;
                  })}
                </Select>
                {!isValidated && <FormHelperText id="errorHelperText">{errorMessage}</FormHelperText>}
              </FormControl>
            </>
          )}

          {/*Slider Option*/}
          {type === "range" && (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center", // optional if vertical centering isn't needed
                width: "100%",
              }}
            >
              <Slider
                sx={{ width: 300 }}
                aria-label="Always visible"
                value={sliderValue}
                valueLabelDisplay="off"
                onChange={(e, newValue) => {
                  setSliderValue(newValue?.toString());
                  changeSliderValue(newValue?.toString());
                }}
                step={inputParams.step}
                marks={marks}
                min={inputParams.min}
                max={inputParams.max}
              />
            </Box>
          )}
        </div>
      </fieldset>
    </>
  );
};

export default function SelectService(props) {
  const { t } = useTranslation();
  const errorNoServiceType = useRef(false);

  const [showErrorDialog, setShowErrorDialog] = useState(false);
  const [showFutureError, setShowFutureError] = useState(false);
  const [showDateError, setShowDateError] = useState(false);
  const [selectNowTime, setSelectNowTime] = useState(false);
  const [serviceTypes, setServiceTypes] = useState(undefined);
  const [towReasonsList, setTowReasonsList] = useState(
    props.currState.towReasons?.length ? props.currState.towReasons : [],
  );
  const [hasShown3PlusRidersMsg, setHasShown3PlusRidersMsg] = useState(false);
  const [showRiderWarning, setShowRiderWarning] = useState(false);
  const [productServiceTypeLimits, setProductServiceTypeLimits] = useState(
    props.currState.productServiceTypeLimits || [],
  );
  const [subPartnerName, setSubPartnerName] = useState(props.currState?.appConfig?.subPartnerName || "");

  const [fullCampaignDetails, setFullCampaignDetails] = useState(() => props.currState.campaignDetails || []);
  const fullCampaignDetailsRef = useRef(fullCampaignDetails);

  useEffect(() => {
    fullCampaignDetailsRef.current = fullCampaignDetails;
  }, [fullCampaignDetails]);

  useEffect(() => {
    const next = props.currState.campaignDetails || [];
    if (next.length === 0) return;
    setFullCampaignDetails((prev) => (next.length >= prev.length ? next : prev));
  }, [props.currState.campaignDetails]);

  const applyCampaignDetailsForSelectedService = useCallback(
    (serviceType) => {
      if (props.localGroup !== "PBFL" || typeof props.context?.setState !== "function") return;
      const list = fullCampaignDetailsRef.current || [];
      props.context.setState({
        campaignDetails: list.filter((c) => c.serviceType === serviceType),
      });
    },
    [props.localGroup, props.context],
  );

  useEffect(() => {
    buildServiceTypeOptions();
  }, []);

  useEffect(() => {
    buildServiceTypeOptions();
  }, [props.currState.towReasonRestricted]);

  // Auto-select tow service for Sears Transformco after services are created and rendered
  useEffect(() => {
    if (subPartnerName === "Sears Transformco" && serviceTypes) {
      // Use setTimeout to ensure components are mounted and event listeners are set up
      const timeoutId = setTimeout(() => {
        const towService = serviceTypes.services.find((service) => service.value === SERVICE_TYPE_TOW);
        if (towService) {
          // Always call setSelected to trigger event listeners and update UI
          towService.setSelected(true);
          applyCampaignDetailsForSelectedService(SERVICE_TYPE_TOW);
        }
      }, 100);

      return () => clearTimeout(timeoutId);
    }
  }, [serviceTypes, subPartnerName, applyCampaignDetailsForSelectedService]);

  const yesNoOptions = [
    {
      key: "Yes",
      label: t("description.Yes"),
      value: "Yes",
    },
    {
      key: "No",
      label: t("description.No"),
      value: "No",
    },
  ];

  const winchCircumstance = [
    {
      key: "In Alley",
      label: t("description.WinchInAlley"),
      value: "In Alley",
    },
    {
      key: "Loaded Vehicle",
      label: t("description.WinchLoadedVehicle"),
      value: "Loaded Vehicle",
    },
    {
      key: "Multiple Wheels Stuck",
      label: t("description.WinchMultipleWheelsStuck"),
      value: "Multiple Wheels Stuck",
    },
    {
      key: "Recovery",
      label: t("description.WinchRecovery"),
      value: "Recovery",
    },
    {
      key: "Stuck in Mud",
      label: t("description.WinchStuckInMud"),
      value: "Stuck in Mud",
    },
    {
      key: "Stuck in Sand",
      label: t("description.WinchStuckInSand"),
      value: "Stuck in Sand",
    },
    {
      key: "Stuck in Snow",
      label: t("description.WinchStuckInSnow"),
      value: "Stuck in Snow",
    },
  ];

  const locksmithOptions = [
    {
      key: "Auto",
      label: t("description.ConfirmServicesLocksmithForAuto"),
      value: "Auto Locksmith",
    },
    {
      key: "Home",
      label: t("description.ConfirmServicesLocksmithForHome"),
      value: "Home Locksmith",
    },
  ];

  const fuelOptions = [
    {
      key: "Gas",
      label: t("description.ConfirmServicesGasGas"),
      value: "Gas",
    },
    {
      key: "Diesel",
      label: t("description.ConfirmServicesGasDiesel"),
      value: "Diesel",
    },
  ];

  const driveTrainOptions = [
    {
      key: "2WD",
      label: "2WD",
      value: "2WD",
    },
    {
      key: "4WD",
      label: "4WD",
      value: "4WD",
    },
    {
      key: "AWD",
      label: "AWD",
      value: "AWD",
    },
  ];

  const keyLocationOptions = [
    {
      key: "Ignition",
      label: t("description.Ignition"),
      value: "Ignition",
    },
    {
      key: "Seat",
      label: t("description.Seat"),
      value: "Seat",
    },
    {
      key: "Floor",
      label: t("description.Floor"),
      value: "Floor",
    },
    {
      key: "Trunk",
      label: t("description.Trunk"),
      value: "Trunk",
    },
  ];

  const buildServiceTypeOptions = function () {
    const options = [];

    if (subPartnerName !== "Sears Transformco") {
      /**
       * FIMC Service Types
       */
      if (props.localGroup === "FIMC") {
        /**
         * Locksmith
         */
        options.push({
          label: t("description.ConfirmServicesLocksmith"),
          value: SERVICE_TYPE_LOCKSMITH,
          options: [
            {
              title: t("description.LockSmithType"),
              type: "radio",
              dataKey: "serviceType",
              values: locksmithOptions,
              validationErrorMessage: t("description.MakeASelection"),
              onValidate: (option) => {
                return option.values.map((item) => item.value).includes(option.value);
              },
            },
          ],
          icon: lockoutIcon,
          iconAlt: "locksmith icon",
          selected: false,
        });
      }

      /**
       * ATF Service Types
       */
      if (props.localGroup === "ATF") {
        options.push({
          label: t("description.ConfirmServicesTireSwap"),
          value: SERVICE_TYPE_TIRESWAP,
          options: [],
          icon: tiresIcon,
          iconAlt: "Tire Swap",
          selected: false,
        });
      }

      /**
       * Lockout
       */
      options.push({
        key: "SERVICE_LOCKOUT",
        label: t("description.ConfirmServicesLockout"),
        value: SERVICE_TYPE_LOCKOUT,
        options: [
          {
            title: t("description.KeyLocation"),
            type: "radio",
            dataKey: "keyLocation",
            values: keyLocationOptions,
            validationErrorMessage: t("description.MakeASelection"),
            onValidate: (option) => {
              return option.values.map((item) => item.value).includes(option.value);
            },
          },
          {
            title: t("description.TrunkRelease"),
            type: "radio",
            dataKey: "trunkRelease",
            values: yesNoOptions,
            validationErrorMessage: t("description.MakeASelection"),
            onValidate: (option) => {
              const keyLocationOption = option.getOptionByDataKey("keyLocation").value;

              return (
                (keyLocationOption !== "Trunk" && keyLocationOption !== "") ||
                (keyLocationOption === "Trunk" && option.values.map((item) => item.value).includes(option.value))
              );
            },
            canShow: (option) => {
              const keyLocationOption = option.getOptionByDataKey("keyLocation").value;
              return keyLocationOption === "Trunk";
            },
          },
        ],
        icon: lockoutIcon,
        iconAlt: "lockout icon",
        selected: false,
      });

      /**
       * Fuel
       */
      options.push({
        key: "SERVICE_GAS",
        label:
          props.locale === "US"
            ? t("description.ConfirmServicesGas" + (props.localGroup === "TVL" ? "TVL" : ""))
            : t("description.ConfirmServicesGasCA"),
        value: SERVICE_TYPE_GAS,
        options: [
          {
            title: t("description.ConfirmServicesGasQuestion"),
            type: "radio",
            dataKey: "fuelType",
            values: fuelOptions,
            validationErrorMessage: t("description.MakeASelection"),
            onValidate: (option) => {
              return option.values.map((item) => item.value).includes(option.value);
            },
          },
        ],
        icon: gasIcon,
        iconAlt: "gas icon",
        selected: false,
      });

      /**
       * Jump Start
       */
      options.push({
        key: "SERVICE_BOOST",
        label:
          props.locale === "CA"
            ? t(
                "description.ConfirmServicesBoostCA",
                // +
                //   (props.localGroup === "TVL" ? "TVL" : "")
              )
            : t("description.ConfirmServicesBoost" + (props.localGroup === "TVL" ? "TVL" : "")),
        value: SERVICE_TYPE_BOOST,
        options: [],
        icon: startIcon,
        iconAlt: "jump start icon",
        selected: false,
      });

      /**
       * Tire Change
       */
      options.push({
        key: "SERVICE_FLAT_TIRE",
        label: props.locale === "US" ? t("description.ConfirmServicesFlat") : t("description.ConfirmServicesFlatCA"),
        value: SERVICE_TYPE_FLAT,
        options: [
          {
            title: t("description.WorkingSpare"),
            type: "radio",
            dataKey: "workingSpare",
            values: yesNoOptions,
            validationErrorMessage: t("description.MakeASelection"),
            onValidate: (option) => {
              return option.values.map((item) => item.value).includes(option.value);
            },
          },
          {
            title: t("description.LockLugNuts"),
            type: "radio",
            dataKey: "lockLugNuts",
            values: yesNoOptions,
            validationErrorMessage: t("description.MakeASelection"),
            onValidate: (option) => {
              const workingSpareOpt = option.getOptionByDataKey("workingSpare").value;
              return (
                workingSpareOpt === "No" ||
                (workingSpareOpt === "Yes" && option.values.map((item) => item.value).includes(option.value))
              );
            },
            canShow: (option) => {
              const workingSpareOpt = option.getOptionByDataKey("workingSpare").value;
              return workingSpareOpt === "Yes";
            },
          },
          {
            title: t("description.LockLugNutsKey"),
            type: "radio",
            dataKey: "haveLockLugNutsKey",
            values: yesNoOptions,
            validationErrorMessage: t("description.MakeASelection"),
            onValidate: (option) => {
              const workingSpareOpt = option.getOptionByDataKey("workingSpare").value;
              const lockLugNutsOpt = option.getOptionByDataKey("lockLugNuts").value;
              return (
                (lockLugNutsOpt === "No" && workingSpareOpt === "Yes") ||
                workingSpareOpt === "No" ||
                (workingSpareOpt === "Yes" && option.values.map((item) => item.value).includes(option.value))
              );
            },
            canShow: (option) => {
              const lockLugNutsOpt = option.getOptionByDataKey("lockLugNuts").value;
              return lockLugNutsOpt === "Yes";
            },
          },
        ],
        icon: tiresIcon,
        iconAlt: "flat tire icon",
        selected: false,
      });

      /**
       * Winch
       */
      options.push({
        key: "SERVICE_WINCH",
        label: t("description.ConfirmServicesWinch" + (props.localGroup === "TVL" ? "TVL" : "")),
        value: SERVICE_TYPE_WINCH,
        icon: winchIcon,
        iconAlt: "winch icon",
        selected: false,
        options: [
          {
            title: t("description.WinchCircumstance"),
            type: "dropdown",
            dataKey: "winchCircumstance",
            values: winchCircumstance,
            validationErrorMessage: t("description.MakeASelection"),
            onValidate: (option) => {
              return option.values.map((item) => item.value).includes(option.value);
            },
          },
          {
            title: props.locale === "CA" ? t("description.WinchDistanceMeter") : t("description.WinchDistanceFeet"),
            type: "input",
            dataKey: "winchDistance",
            inputType: "number",
            validationErrorMessage: t("description.MakeASelection"),
            onValidate: (option) => {
              return option.values.map((item) => item.value !== "" || !item.value);
            },
          },
        ],
      });
    }

    /**
     * Tow
     */
    const isTowReasonRestricted = !!props?.currState?.towReasonRestricted;
    const _towReasons = isTowReasonRestricted
      ? towReasonsList.map((reason, index) => {
          return {
            key: reason.key,
            label: reason.value,
            value: reason.key,
          };
        })
      : [];

    const service_tow = {
      key: "SERVICE_TOW",
      label: t("description.ConfirmServicesTow"),
      value: SERVICE_TYPE_TOW,
      icon: towIcon,
      iconAlt: "tow icon",
      options: [],
      selected: false,
    };

    /*Rider Number*/
    service_tow.options.push({
      title: t("description.Riders"),
      type: "range",
      inputParams: {
        min: 0,
        max: 3,
        step: 1,
      },

      dataKey: "riderCount",
    });

    /*If Tire Roll*/
    service_tow.options.push({
      title: t("description.TiresRoll"),
      type: "radio",
      values: yesNoOptions,
      dataKey: "ifTiresIntactRoll",
      validationErrorMessage: t("description.MakeASelection"),
      onValidate: (option) => {
        return option.values.map((item) => item.value).includes(option.value);
      },
    });

    /*Tow Reasons*/
    if (_towReasons && _towReasons.length && isTowReasonRestricted) {
      service_tow.options.push({
        title: t("description.TowReason"),
        type: "dropdown",
        values: _towReasons,
        dataKey: "towReason",
        validationErrorMessage: t("description.MakeASelection"),
        onValidate: (option) => {
          return option.values.map((item) => item.value).includes(option.value);
        },
      });
    }

    /*Drivetrain*/
    service_tow.options.push({
      title: t("description.Drivetrain"),
      type: "radio",
      values: driveTrainOptions,
      dataKey: "drivetrain",
      validationErrorMessage: t("description.MakeASelection"),
      onValidate: (option) => {
        return option.values.map((item) => item.value).includes(option.value);
      },
    });

    /*Shift Into Neutral*/
    service_tow.options.push({
      title: t("description.ShiftToNeutral"),
      type: "radio",
      values: yesNoOptions,
      dataKey: "shiftNeutral",
      validationErrorMessage: t("description.MakeASelection"),
      onValidate: (option) => {
        return option.values.map((item) => item.value).includes(option.value);
      },
      canShow: (option) => {
        const drivetrainOption = option.getOptionByDataKey("drivetrain");
        return !!drivetrainOption?.value;
      },
    });

    /*Height Restriction*/
    service_tow.options.push({
      title: t("description.HasHeightRestriction"),
      type: "radio",
      values: yesNoOptions,
      dataKey: "hasHeightRestriction",
      validationErrorMessage: t("description.MakeASelection"),
      onValidate: (option) => {
        return option.values.map((item) => item.value).includes(option.value);
      },
      canShow: (option) => {
        const neutralOption = option.getOptionByDataKey("shiftNeutral");
        return !!neutralOption?.value;
      },
    });

    const heightOptions = [];
    for (let i = 1; i <= 10; i++) {
      heightOptions.push({
        key: i.toString(),
        label: i,
        value: i,
      });
    }

    /*Height*/
    service_tow.options.push({
      title: props.locale === "CA" ? t("description.RestrictionHeightCAN") : t("description.RestrictionHeightUS"),
      type: "dropdown",
      values: heightOptions,
      dataKey: "heightRestriction",
      validationErrorMessage: t("description.MakeASelection"),
      onValidate: (option) => {
        const hasHeightRestriction = option.getOptionByDataKey("hasHeightRestriction").value;
        return (
          hasHeightRestriction === "No" ||
          (hasHeightRestriction === "Yes" && option.values.map((item) => item.value).includes(option.value))
        );
      },
      canShow: (option) => {
        const hasHeightRestrictionOpt = option.getOptionByDataKey("hasHeightRestriction");
        return hasHeightRestrictionOpt?.value === "Yes";
      },
    });

    options.push(service_tow);

    // if (props.localGroup !== "PBFL") {
    //   options.push(service_tow);
    // }

    if (props.localGroup === "PBFL") {
      const towIndex = options.findIndex((s) => s.value === SERVICE_TYPE_TOW);
      if (towIndex > 0) {
        const [towService] = options.splice(towIndex, 1);
        options.unshift(towService);
      }
    }

    const st = new ServiceTypeDataHost(options);
    setServiceTypes(st);
  };

  const [errorMsg, setErrorMsg] = useState("");
  const [showWorkingSpareMsg, setShowWorkingSpareMsg] = useState("");

  function onSubmit(e) {
    if (e && typeof e.preventDefault === "function") {
      e.preventDefault();
    }
    const data = serviceTypes.getData();
    const isValidated = serviceTypes.validate();
    data.scheduledEventDate = ALLOW_SCHEDULE_FOR_LATER && needFutureService === "Yes" ? selectedDate : "";

    setShowFutureError(false);
    setShowDateError(false);
    setSelectNowTime(false);

    if (!isValidated) {
      return;
    }

    if (!data.serviceType) {
      setShowErrorDialog(true);
      setErrorMsg("description.ConfirmServicesError");
      errorNoServiceType.current = true;
      return;
    }

    if (ALLOW_SCHEDULE_FOR_LATER && !needFutureService) {
      setShowFutureError(true);
      return;
    }

    if (data.serviceType === "Flat" && data.workingSpare === "No") {
      setShowErrorDialog(true);
      setErrorMsg("description.NoHavingSpareMsg");
      return;
    } else if (data.serviceType === "Flat" && data.haveLockLugNutsKey === "No") {
      setShowErrorDialog(true);
      setErrorMsg("description.NotHaveKeyLugNutsMsg");
      return;
    } else if (data.serviceType === "Lockout" && data.trunkRelease === "No" && data.keyLocation === "Trunk") {
      setShowErrorDialog(true);
      setErrorMsg("description.NotHaveWorkingTrunkReleaseMsg");
      return;
    }

    if (data.serviceType === "Tow" && data.heightRestriction !== undefined) {
      data.heightRestriction = props.locale === "US" ? data.heightRestriction + "ft" : data.heightRestriction + "m";
    }
    if (data.serviceType === "Winch" && data.winchDistance !== undefined) {
      data.winchDistance = props.locale === "US" ? data.winchDistance + "ft" : data.winchDistance + "m";
    }

    if (data.riderCount === 3 && !hasShown3PlusRidersMsg) {
      setShowRiderWarning(true);
      setErrorMsg("description.3PlusRidersMsg");
      setHasShown3PlusRidersMsg(true);
      return;
    }

    if (ALLOW_SCHEDULE_FOR_LATER) {
      if (!selectedDate && needFutureService === "Yes") {
        setShowDateError(true);
        return;
      } else if (needFutureService === "Yes" && (selectedDate === now || selectedDate < now)) {
        setSelectNowTime(true);
        return;
      }
    }

    setShowErrorDialog(false);
    errorNoServiceType.current = false;
    if (typeof props.onUserNext === "function") {
      props.onUserNext(data);
    }
  }

  const setDialogWrapper = () => {
    setShowErrorDialog(false);
    setShowFutureError(false);
    setShowDateError(false);
    setSelectNowTime(false);
    setErrorMsg("");
    errorNoServiceType.current = false;
  };

  const [selectedDate, setSelectedDate] = useState("");
  const [currDate, setCurrDate] = useState(new Date());
  const [minTime, setMinTime] = useState(new Date());
  const now = new Date();
  const [isToday, setIsToday] = useState(currDate.toDateString() === now.toDateString());

  useEffect(() => {
    if (!selectedDate) return;

    const selected = new Date(selectedDate);
    const now = new Date();
    const isSameDay = selected.toDateString() === now.toDateString();

    setIsToday(isSameDay);

    setMinTime(
      isSameDay
        ? new Date(now.getTime() + 30 * 60000) // 30 mins from now
        : new Date(0, 0, 0, 0, 0), // Midnight (start of the day)
    );
  }, [selectedDate]);

  const maxTime = new Date(0, 0, 0, 23, 59);
  const [needFutureService, setNeedFutureService] = useState(false);

  const dateData = {
    title: t("description.ScheduleServiceQuestion"),
    type: "dateTime",
    dataKey: "scheduleService",
    values: yesNoOptions,
    validationErrorMessage: t("description.ConfirmServicesMissScheduleService"),
    onValidate: (option) => {
      return option.values.map((item) => item.value).includes(option.value);
    },
  };

  return (
    <div className="formContainer">
      {showErrorDialog && (
        <Dialog
          config={true}
          title={"PaymentRequiredHeader1"}
          message={<Fragment>{t(errorMsg)}</Fragment>}
          onClose={setDialogWrapper}
          buttonTitle={"Close"}
        />
      )}
      {showRiderWarning && (
        <Dialog
          config={true}
          title={"PaymentRequiredHeader1"}
          message={<Fragment>{t(errorMsg)}</Fragment>}
          onClose={onSubmit}
          buttonTitle={"Next"}
        />
      )}
      <form className="form">
        {/* <form onSubmit={onSubmit} className="form"> */}
        {serviceTypes ? (
          <SelectServiceList
            dataHost={serviceTypes}
            productServiceTypeLimits={productServiceTypeLimits}
            campaignDetails={fullCampaignDetails}
            partnerCode={props.localGroup}
            onServiceCampaignSelected={applyCampaignDetailsForSelectedService}
          />
        ) : (
          <></>
        )}

        {ALLOW_SCHEDULE_FOR_LATER && (
          <fieldset id="group1">
            <div
              style={{
                background: "white",
                padding: 24,
                borderBottom: "1px solid lightgray",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <FormControl error={showFutureError}>
                <FormLabel id="demo-radio-buttons-group-label" style={{ color: "#212529" }}>
                  {dateData.title}
                </FormLabel>
                <RadioGroup
                  aria-labelledby="demo-controlled-radio-buttons-group"
                  name="controlled-radio-buttons-group"
                  value={needFutureService}
                >
                  {dateData.values?.length > 0 &&
                    dateData.values.map((item, index) => (
                      <FormControlLabel
                        key={`schedule-option-${item.value}-${index}`}
                        value={item.value}
                        control={<Radio />}
                        label={" " + item.label}
                        onChange={(e) => {
                          e.preventDefault();
                          setNeedFutureService(item.value);
                        }}
                      />
                    ))}
                </RadioGroup>
              </FormControl>
              {showFutureError && (
                <FormHelperText id="errorHelperText" style={{ color: "red" }}>
                  {t("description.ConfirmServicesMissScheduleService")}
                </FormHelperText>
              )}
            </div>
          </fieldset>
        )}

        {ALLOW_SCHEDULE_FOR_LATER && needFutureService === "Yes" && (
          <fieldset id="group1">
            <div
              style={{
                background: "white",
                padding: 24,
                borderBottom: "1px solid lightgray",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <FormControl error={showDateError}>
                <FormLabel
                  id="demo-radio-buttons-group-label"
                  style={{
                    color: "#212529",
                    marginBottom: "10px",
                  }}
                >
                  {t("description.ScheduleServiceTime")}
                </FormLabel>
                <DatePicker
                  className="datePicker"
                  showTimeSelect
                  minDate={new Date()}
                  minTime={minTime}
                  maxTime={maxTime}
                  selected={selectedDate}
                  onChange={(date) => {
                    setSelectedDate(date);
                  }}
                  placeholderText={"Please select a date"}
                  dateFormat="MMMM d, yyyy h:mmaa"
                />
              </FormControl>
              {(showDateError || selectNowTime) && (
                <FormHelperText id="errorHelperText" style={{ color: "red" }}>
                  {t("description.ScheduleServiceTimeError")}
                </FormHelperText>
              )}
            </div>
          </fieldset>
        )}

        <div className="footerContainer" style={{ display: "flex" }}>
          <div>
            <button
              id="cancelButton"
              type="button"
              className="footer"
              style={{ background: "#f4f4f4", color: "black", paddingLeft: 14 }}
              onClick={() => {
                if (typeof props.onUserCancel === "function") {
                  props.onUserCancel();
                }
              }}
            >
              <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />
              <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
            </button>
          </div>
          <div>
            <button type="submit" className="ui-btn" onClick={onSubmit}>
              {t("description.ConfirmServicesSubmit")}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
